export const costRanges = {
  "Arizona|family|child-custody|I want shared custody with my partner|*": {
    min: 2000,
    max: 6000,
    state: "Arizona",
  },
  "Arizona|family|child-custody|I want a divorce involving child custody|*": {
    min: 2000,
    max: 6000,
    state: "Arizona",
  },
  "Arizona|family|child-custody|I want to change a custody court order|*": {
    min: 3250,
    max: 4050,
    state: "Arizona",
  },
  "Arizona|family|child-custody|I want to file for sole custody|*": {
    min: 2950,
    max: 3650,
    state: "Arizona",
  },
  "Arizona|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Arizona",
  },
  "Arizona|family|divorce|I'm looking to initiate a divorce|No": {
    min: 3200,
    max: 3550,
    state: "Arizona",
  },
  "Arizona|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 2950,
    max: 3600,
    state: "Arizona",
  },
  "Arizona|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Arizona",
  },
  "Arizona|family|divorce|I want a divorce involving child custody|*": {
    min: 3350,
    max: 3950,
    state: "Arizona",
  },
  "California|family|child-custody|I want a divorce involving child custody|*":
    { min: 2000, max: 6000, state: "California" },
  "California|family|child-custody|I want to change a custody court order|*": {
    min: 5050,
    max: 5700,
    state: "California",
  },
  "California|family|child-custody|I want to file for sole custody|*": {
    min: 5400,
    max: 6200,
    state: "California",
  },
  "California|family|child-custody|I want shared custody with my partner|*": {
    min: 5400,
    max: 6150,
    state: "California",
  },
  "California|family|child-support|I need assistance with overdue child support|*":
    { min: 2000, max: 6000, state: "California" },
  "California|family|child-support|I want to file for child support|*": {
    min: 2000,
    max: 6000,
    state: "California",
  },
  "California|family|child-support|I'd like to change my current child support terms|*":
    { min: 4200, max: 5000, state: "California" },
  "California|family|child-support|Something else|*": {
    min: 2000,
    max: 6000,
    state: "California",
  },
  "California|family|divorce|I'm looking to initiate a divorce|No": {
    min: 3750,
    max: 4050,
    state: "California",
  },
  "California|family|divorce|I want a divorce involving child custody|No": {
    min: 4550,
    max: 5000,
    state: "California",
  },
  "California|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 4050,
    max: 4600,
    state: "California",
  },
  "California|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "California",
  },
  "Colorado|family|child-custody|I want to file for sole custody|*": {
    min: 2000,
    max: 6000,
    state: "Colorado",
  },
  "Colorado|family|child-custody|I want to change a custody court order|*": {
    min: 3550,
    max: 4500,
    state: "Colorado",
  },
  "Colorado|family|child-custody|I want shared custody with my partner|*": {
    min: 3850,
    max: 4800,
    state: "Colorado",
  },
  "Colorado|family|child-support|I'd like to change my current child support terms|*":
    { min: 2000, max: 6000, state: "Colorado" },
  "Colorado|family|child-support|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Colorado",
  },
  "Colorado|family|divorce|I'm looking to initiate a divorce|No": {
    min: 4500,
    max: 5000,
    state: "Colorado",
  },
  "Colorado|family|divorce|I want to respond to a divorce petition|*": {
    min: 2000,
    max: 6000,
    state: "Colorado",
  },
  "Colorado|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Colorado",
  },
  "Colorado|family|divorce|I want a divorce involving child custody|*": {
    min: 4200,
    max: 5100,
    state: "Colorado",
  },
  "Florida|family|child-custody|I want to change a custody court order|*": {
    min: 3400,
    max: 3950,
    state: "Florida",
  },
  "Florida|family|child-custody|I want shared custody with my partner|*": {
    min: 3250,
    max: 3700,
    state: "Florida",
  },
  "Florida|family|child-custody|I want to file for sole custody|*": {
    min: 3550,
    max: 4000,
    state: "Florida",
  },
  "Florida|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Florida",
  },
  "Florida|family|child-support|I want to file for child support|*": {
    min: 2000,
    max: 6000,
    state: "Florida",
  },
  "Florida|family|child-support|I need assistance with overdue child support|*":
    { min: 3050, max: 3750, state: "Florida" },
  "Florida|family|child-support|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Florida",
  },
  "Florida|family|child-support|I'd like to change my current child support terms|*":
    { min: 3100, max: 3850, state: "Florida" },
  "Florida|family|divorce|I'm looking to initiate a divorce|No": {
    min: 3350,
    max: 3550,
    state: "Florida",
  },
  "Florida|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 3300,
    max: 3750,
    state: "Florida",
  },
  "Florida|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Florida",
  },
  "Florida|family|divorce|I want a divorce involving child custody|*": {
    min: 3400,
    max: 3700,
    state: "Florida",
  },
  "Florida|family|child-custody|I want a divorce involving child custody|*": {
    min: 3350,
    max: 3900,
    state: "Florida",
  },
  "Georgia|family|child-custody|I want to change a custody court order|*": {
    min: 3100,
    max: 3700,
    state: "Georgia",
  },
  "Georgia|family|child-custody|I want shared custody with my partner|*": {
    min: 3250,
    max: 3950,
    state: "Georgia",
  },
  "Georgia|family|child-custody|I want to file for sole custody|*": {
    min: 3650,
    max: 4450,
    state: "Georgia",
  },
  "Georgia|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Georgia",
  },
  "Georgia|family|divorce|I'm looking to initiate a divorce|No": {
    min: 3350,
    max: 3550,
    state: "Georgia",
  },
  "Georgia|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 3300,
    max: 3800,
    state: "Georgia",
  },
  "Georgia|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Georgia",
  },
  "Georgia|family|divorce|I want a divorce involving child custody|*": {
    min: 3500,
    max: 3900,
    state: "Georgia",
  },
  "Georgia|family|child-custody|I want a divorce involving child custody|*": {
    min: 3150,
    max: 4000,
    state: "Georgia",
  },
  "Illinois|family|child-custody|I want to change a custody court order|*": {
    min: 2000,
    max: 6000,
    state: "Illinois",
  },
  "Illinois|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Illinois",
  },
  "Illinois|family|child-custody|I want shared custody with my partner|*": {
    min: 3500,
    max: 4450,
    state: "Illinois",
  },
  "Illinois|family|child-custody|I want to file for sole custody|*": {
    min: 3900,
    max: 4850,
    state: "Illinois",
  },
  "Illinois|family|divorce|I'm looking to initiate a divorce|No": {
    min: 3900,
    max: 4450,
    state: "Illinois",
  },
  "Illinois|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 4150,
    max: 5150,
    state: "Illinois",
  },
  "Illinois|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Illinois",
  },
  "Illinois|family|divorce|I want a divorce involving child custody|*": {
    min: 3850,
    max: 4550,
    state: "Illinois",
  },
  "Maryland|family|child-custody|I want shared custody with my partner|*": {
    min: 2000,
    max: 6000,
    state: "Maryland",
  },
  "Maryland|family|child-custody|I want to change a custody court order|*": {
    min: 2000,
    max: 6000,
    state: "Maryland",
  },
  "Maryland|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Maryland",
  },
  "Maryland|family|child-custody|I want to file for sole custody|*": {
    min: 3300,
    max: 4200,
    state: "Maryland",
  },
  "Maryland|family|divorce|I'm looking to initiate a divorce|No": {
    min: 3300,
    max: 3650,
    state: "Maryland",
  },
  "Maryland|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 3450,
    max: 4400,
    state: "Maryland",
  },
  "Maryland|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Maryland",
  },
  "Maryland|family|divorce|I want a divorce involving child custody|*": {
    min: 3250,
    max: 3750,
    state: "Maryland",
  },
  "Michigan|family|child-custody|I want shared custody with my partner|*": {
    min: 2000,
    max: 6000,
    state: "Michigan",
  },
  "Michigan|family|child-custody|I want to change a custody court order|*": {
    min: 3450,
    max: 4100,
    state: "Michigan",
  },
  "Michigan|family|child-custody|I want to file for sole custody|*": {
    min: 3050,
    max: 3750,
    state: "Michigan",
  },
  "Michigan|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Michigan",
  },
  "Michigan|family|divorce|I'm looking to initiate a divorce|No": {
    min: 2950,
    max: 3300,
    state: "Michigan",
  },
  "Michigan|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 3000,
    max: 3800,
    state: "Michigan",
  },
  "Michigan|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Michigan",
  },
  "Michigan|family|divorce|I want a divorce involving child custody|*": {
    min: 3100,
    max: 3600,
    state: "Michigan",
  },
  "Michigan|family|child-custody|I want a divorce involving child custody|*": {
    min: 3700,
    max: 4650,
    state: "Michigan",
  },
  "New York|family|child-custody|I want to change a custody court order|*": {
    min: 2000,
    max: 6000,
    state: "New York",
  },
  "New York|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "New York",
  },
  "New York|family|child-custody|I want shared custody with my partner|*": {
    min: 2000,
    max: 6000,
    state: "New York",
  },
  "New York|family|child-custody|I want to file for sole custody|*": {
    min: 3850,
    max: 4750,
    state: "New York",
  },
  "New York|family|divorce|I'm looking to initiate a divorce|No": {
    min: 3400,
    max: 3800,
    state: "New York",
  },
  "New York|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 3250,
    max: 4150,
    state: "New York",
  },
  "New York|family|divorce|I want a divorce involving child custody|*": {
    min: 2000,
    max: 6000,
    state: "New York",
  },
  "New York|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "New York",
  },
  "Texas|family|child-custody|I want to change a custody court order|*": {
    min: 4850,
    max: 5450,
    state: "Texas",
  },
  "Texas|family|child-custody|I want to file for sole custody|*": {
    min: 4900,
    max: 5450,
    state: "Texas",
  },
  "Texas|family|child-custody|I want shared custody with my partner|*": {
    min: 4700,
    max: 5500,
    state: "Texas",
  },
  "Texas|family|child-custody|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Texas",
  },
  "Texas|family|child-support|I want to file for child support|*": {
    min: 2000,
    max: 6000,
    state: "Texas",
  },
  "Texas|family|child-support|I'd like to change my current child support terms|*":
    { min: 3950, max: 4700, state: "Texas" },
  "Texas|family|child-support|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Texas",
  },
  "Texas|family|child-support|I need assistance with overdue child support|*": {
    min: 4400,
    max: 5400,
    state: "Texas",
  },
  "Texas|family|divorce|I'm looking to initiate a divorce|No": {
    min: 4250,
    max: 4500,
    state: "Texas",
  },
  "Texas|family|divorce|I want to respond to a divorce petition|Yes": {
    min: 4250,
    max: 4750,
    state: "Texas",
  },
  "Texas|family|divorce|Something else|*": {
    min: 2000,
    max: 6000,
    state: "Texas",
  },
  "Texas|family|divorce|I want a divorce involving child custody|*": {
    min: 4800,
    max: 5200,
    state: "Texas",
  },
};
